import {
    setCookie,
    initMenuTrigger,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    // addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    accordionService,
    initLazyBg,
    initShow,
    initCounting
} from './functions';




// GLightbox ładowany jest dynamicznie z plugins/glightbox/ tylko gdy na stronie są elementy lightboxa.




//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow('animUp');
    initShow('animDown');
    initShow('animLeft');
    initShow('animRight');

    // init menu trigger
    initMenuTrigger();

    // init counting animation for span.counting
    initCounting();

    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow ...
    addFancyboxFixForGallery('.wp-block-gallery');
    addFancyboxFixForGallery('.wp-block-image');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    //addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();

    accordionService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            const scrollTarget = $(this).offset().top;
            $('html,body').animate({ 'scrollTop': scrollTarget + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder')[0].scrollTop = 0;
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        const viewportWidth = window.innerWidth;
        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (viewportWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if (target.length > 1) {
                var targetOffset = $(target).offset().top - 140;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 500);
            }
            return false;
        });


        if (window.location.hash) {
            window.setTimeout(() => {
                var target = window.location.hash;
                if ($(target).length > 0) {
                    var targetOffset = $(target).offset().top - 140;
                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 500);
                }
            }, 500);

        }

        $('.gAtuty__menuItem').on('click', function () {
            const target = $(this).data('target');
            $('.gAtuty__menuItem').removeClass('active');
            $(this).addClass('active');
            $('.gAtuty__contentItem').removeClass('active');
            $(`.gAtuty__contentItem#${target}`).addClass('active');

        });

        // WeakSet zapewnia, że getComputedStyle wywoła się maks. raz na element (forced reflow fix).
        const hoverChecked = new WeakSet();
        document.addEventListener('mouseenter', (e) => {
            const el = e.target;
            if (!(el instanceof HTMLAnchorElement || el instanceof HTMLButtonElement)) return;
            if (hoverChecked.has(el)) return;
            hoverChecked.add(el);
            if (getComputedStyle(el, '::after').animationName === 'moveRightFade') {
                el.classList.add('was-hovered');
            }
        }, true);



        $('.gOffer__menuItem').on('click', function () {
            const target = $(this).data('target');
            $('.gOffer__menuItem').removeClass('active');
            $(this).addClass('active');

            $('.gOffer__contentItem').removeClass('active');
            $(`.gOffer__contentItem#${target}`).addClass('active');

            $(`.gOffer__contentItem#${target} .gOffer__contentItem-galleryInner`).each(function () {
                if ($(this).hasClass('slick-initialized')) {
                    $(this).slick('setPosition');
                    $(this).slick('refresh');
                }
            });
        });
        // Inicjalizujemy slidery dopiero gdy zbliżają się do viewportu – żeby nie blokować
        // głównego wątku tuż po DOMContentLoaded (Slick wymusza reflow/layout przy starcie).
        const deferSlick = (selector, options) => {
            const els = document.querySelectorAll(selector);
            if (!els.length) return;
            if (!('IntersectionObserver' in window)) {
                els.forEach((el) => jQuery(el).slick(options));
                return;
            }
            const io = new IntersectionObserver((entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        jQuery(entry.target).slick(options);
                        obs.unobserve(entry.target);
                    }
                });
            }, { rootMargin: '200px 0px' });
            els.forEach((el) => io.observe(el));
        };

        deferSlick('.gOffer__contentItem-galleryInner', {
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: false,
            speed: 500,
            autoplaySpeed: 3000,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });

        deferSlick('.realizacjaGallery__slider', {
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: false,
            speed: 500,
            autoplaySpeed: 3000,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        if ($('.gRealizacje__slider--1').length > 0 || $('.gRealizacje__slider--2').length > 0) {
            // Wspólne ustawienia obu sliderów (autoplay wyłączony – obsługujemy ręcznie,
            // żeby --1 i --2 były perfekcyjnie zsynchronizowane i pauzowały razem na hover).
            const sliderOpts = {
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: false,
                speed: 1000,
                slidesToShow: 4,
                slidesToScroll: 1,
                centerMode: true,
                variableWidth: true,
                responsive: [
                    { breakpoint: 992, settings: { slidesToShow: 3 } },
                    { breakpoint: 768, settings: { slidesToShow: 2 } },
                    { breakpoint: 480, settings: { slidesToShow: 1 } }
                ]
            };

            const initGRealizacje = () => {
                const $s1 = $('.gRealizacje__slider--1').length ? jQuery('.gRealizacje__slider--1').slick(sliderOpts) : null;
                const $s2 = $('.gRealizacje__slider--2').length ? jQuery('.gRealizacje__slider--2').slick(sliderOpts) : null;

                // Wspólny tick: --1 jedzie w prawo, --2 w lewo, jednocześnie.
                const cycle = 3000;
                const tick = function () {
                    if ($s1) $s1.slick('slickNext');
                    if ($s2) $s2.slick('slickPrev');
                };
                let timer = setInterval(tick, cycle);
                const stop = function () {
                    if (timer) { clearInterval(timer); timer = null; }
                };
                const start = function () {
                    if (!timer) timer = setInterval(tick, cycle);
                };

                // Hover/focus na wspólnym kontenerze .gRealizacje – pauzuje OBA slidery.
                const $wrap = jQuery('.gRealizacje');
                $wrap.on('mouseenter focusin', stop)
                    .on('mouseleave focusout', start);
                document.addEventListener('visibilitychange', function () {
                    document.hidden ? stop() : start();
                });
            };

            const wrapEl = document.querySelector('.gRealizacje');
            if (wrapEl && 'IntersectionObserver' in window) {
                const io = new IntersectionObserver((entries, obs) => {
                    if (entries[0].isIntersecting) {
                        obs.disconnect();
                        initGRealizacje();
                    }
                }, { rootMargin: '200px 0px' });
                io.observe(wrapEl);
            } else {
                initGRealizacje();
            }
        }


        $('.realizacjeSidebar__rozwin').on('click', function () {
            $(this).parent().toggleClass('showAll');

        });




        const glightboxSelector = ".woocommerce-product-gallery__image a,.glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a";
        if ($(glightboxSelector).length > 0) {
            const base = (typeof ajaxParams !== 'undefined' && ajaxParams.themeUrl) ? ajaxParams.themeUrl : '';

            if (!document.querySelector('link[data-glightbox]')) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = base + '/plugins/glightbox/glightbox.min.css';
                link.dataset.glightbox = '1';
                document.head.appendChild(link);
            }

            const initLightbox = () => {
                if (typeof window.GLightbox !== 'function') return;
                window.GLightbox({
                    selector: glightboxSelector,
                    slideEffect: 'fade',
                    loop: true,
                    dragAutoSnap: true,
                });
            };

            if (typeof window.GLightbox === 'function') {
                initLightbox();
            } else if (!document.querySelector('script[data-glightbox]')) {
                const script = document.createElement('script');
                script.async = true;
                script.src = base + '/plugins/glightbox/glightbox.min.js';
                script.dataset.glightbox = '1';
                script.onload = initLightbox;
                document.head.appendChild(script);
            }
        }



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);








